import { render, staticRenderFns } from "./text-field-tertiary.vue?vue&type=template&id=73dd0eda&scoped=true"
import script from "./text-field-tertiary.vue?vue&type=script&lang=js"
export * from "./text-field-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dd0eda",
  null
  
)

export default component.exports